import { FieldsRenderer } from '@neo/blocks/forms/fields-renderer'
import type { GenericFormType } from '@neo/blocks/forms/types'
import type React from 'react'
import { z } from 'zod'
import { NodevarList } from '../../components/nodevar-list'
import { SecretVariablesPopover } from '../../components/secret-variables.popover'
import type { HttpRequestNodeData } from '../../types'

type AuthTabProps = {
  form: GenericFormType<HttpRequestNodeData['config']>
  nodeVars: string[]
}

export const AuthTab: React.FC<AuthTabProps> = ({ form, nodeVars }) => (
  <div>
    <FieldsRenderer
      fields={[
        {
          label: 'Auth Type',
          name: 'http_request.auth_type',
          componentType: 'select',
          className: 'mt-2',
          zodValidation: z.string().optional(),
          inputProps: {
            placeholder: 'Select Auth Type',
            options: [
              { value: 'no_auth', label: 'No Auth' },
              { value: 'basic_auth', label: 'Basic Auth' },
              { value: 'bearer_token', label: 'Bearer Token' },
              // { value: 'oauth2', label: 'OAuth 2.0' },
            ],
          },
          afterOnChange: (_values, _, form) => {
            form?.setFieldValue('http_request.auth_params', {})
            form?.setFieldValue('http_request.auth_params.token', '')
            form?.setFieldValue('http_request.auth_params.username', '')
            form?.setFieldValue('http_request.auth_params.password', '')
          },
          type: 'sub-item',
        },
        {
          label: 'Username',
          name: 'http_request.auth_params.username',
          componentType: 'input',
          className: 'mt-2',
          zodValidation: z.string().optional(),
          onChangeListenTo: ['http_request.auth_type'],
          visible: (values) => values.http_request.auth_type === 'basic_auth',
          inputProps: {
            type: 'text',
            placeholder: 'Enter username',
          },
          type: 'sub-item',
        },
        {
          label: 'Password',
          name: 'http_request.auth_params.password',
          componentType: 'inputPassword',
          className: 'mt-2',
          zodValidation: z.string().optional(),
          onChangeListenTo: ['http_request.auth_type'],
          visible: (values) => values.http_request.auth_type === 'basic_auth',
          type: 'sub-item',
          getDynamicProps: () => ({
            inputProps: {
              placeholder: 'Enter password',
              endIcon: (
                <SecretVariablesPopover
                  sideOffset={470}
                  onVariableClick={(variable) => {
                    form.setFieldValue(
                      'http_request.auth_params.password',
                      `{{Secrets.${variable.name}}}`,
                    )
                  }}
                />
              ),
            },
          }),
        },
        {
          label: 'Token',
          name: 'http_request.auth_params.token',
          componentType: 'input',
          className: 'mt-2',
          zodValidation: z.string().optional(),
          visible: (values) => values.http_request.auth_type === 'bearer_token',
          onChangeListenTo: ['http_request.auth_type'],
          type: 'sub-item',
          getDynamicProps: () => ({
            inputProps: {
              type: 'text',
              placeholder: 'Enter token',
              endIcon: (
                <div className="flex items-center">
                  <NodevarList
                    nodevars={nodeVars}
                    className="pr-2 bg-background"
                    inputElementSelector="#http_request.auth_params.token"
                  />
                  <SecretVariablesPopover
                    sideOffset={470}
                    onVariableClick={(variable) => {
                      form.setFieldValue(
                        'http_request.auth_params.token',
                        `{{Secrets.${variable.name}}}`,
                      )
                    }}
                  />
                </div>
              ),
            },
          }),
        },
      ]}
      form={form}
    />
  </div>
)
